import React, { lazy, Suspense, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { AutoAwesome, East, West } from '@mui/icons-material';
import CommentSection from './CommentSection';
import { categoryAll } from '../../Datas/categoryPosts';
import { title } from '../../config/config';
import SEO from '../../config/SEO';
const CategoryPromptItem = lazy(() => import("./CategoryPromptItem"));


export const getGuide = (nameOfList = "your image") => [
     {
          title: "1. Open Gemini",
          desc: "Open the Gemini app or web version and make sure you’re logged in."
     },
     {
          title: "2. Choose Image Generation",
          desc: "Look for the image generation option (usually shown as 'Create image' or similar)."
     },
     {
          title: "3. Upload Your Original Image",
          desc: `Click the upload button and select your original ${nameOfList} image. Wait until it fully loads before pasting the prompt.`
     },
     {
          title: "4. Paste the Prompt",
          desc: `Copy one of the ${nameOfList} prompts you liked and paste it into the prompt box.`
     },
     {
          title: "5. Generate the Image",
          desc: "Click Generate and wait for the image to process."
     },
     {
          title: "6. Review the Result",
          desc: `Check the final ${nameOfList} output and make adjustments if needed for better realism.`
     }
];

const CategoryPreview = () => {

     const { categoryId } = useParams();
     const navigate = useNavigate();

     const categoryKeys = Object.keys(categoryAll.categoryPromptList);
     const currentIndex = categoryKeys.indexOf(categoryId);

     const data = categoryAll.categoryPromptList[categoryId];

     // Page change hone par top par scroll karne ke liye
     useEffect(() => {
          window.scrollTo(0, 0);
     }, [categoryId]);

     if (!data) return <div className="not-found">Category Not Found</div>;

     // --- CATEGORY NAVIGATION LOGIC ---
     const handleNextCategory = () => {
          if (currentIndex < categoryKeys.length - 1) {
               const nextCatId = categoryKeys[currentIndex + 1];
               navigate(`/${nextCatId}`);
          }
     };

     const handlePrevCategory = () => {
          if (currentIndex > 0) {
               const prevCatId = categoryKeys[currentIndex - 1];
               navigate(`/${prevCatId}`);
          }
     };

     return (

          <>
               <SEO
                    title={data?.seo_title}
                    description={data?.seo_description}
                    keywords={data?.seo_keywords}
                    canonicalPath={data?.seo_canonicalPath}
               />


               <div className="preview-container">
                    <div className="bg-noise"></div>

                    <header className="hero-header">
                         <div className="meta">
                              <span className="badge">{data.metaBadge.toUpperCase()}</span>
                              <span className="sep">/</span>
                              <span className="category">{data?.collections.toUpperCase()} AI COLLECTION IN {title.toLocaleUpperCase()}</span>
                         </div>
                         <h1>{data.heroTitle}</h1>
                         <p>{data.heroDesc}</p>

                         <div className="hero-actions-bar">
                              <button
                                   className="nav-item prev"
                                   onClick={handlePrevCategory}
                                   disabled={currentIndex === 0}
                              >
                                   <West /> Previous Category
                              </button>

                              <Link to={'/ai-image-generator'} rel="noreferrer" className="generate-btn">
                                   <AutoAwesome /> GENERATE WITH AI
                              </Link>

                              <button
                                   className="nav-item next"
                                   onClick={handleNextCategory}
                                   disabled={currentIndex === categoryKeys.length - 1}
                              >
                                   Next Category <East />
                              </button>
                         </div>
                    </header>

                    <div className="main-banner">
                         <img
                              src={
                                   data?.mainImage?.startsWith("http")
                                        ? data?.mainImage
                                        : `https://res.cloudinary.com/dqwbmkrm8/image/upload/v1772471958/${data?.mainImage}`
                              }
                              alt={data?.title}
                         />
                    </div>

                    {/* Yahan 10 ke 10 prompts list mein dikhenge (Working as you wanted) */}
                    <section className="prompts-list">
                         <Suspense fallback={<p className='text-center'>Loading</p>}>
                              <CategoryPromptItem
                                   categoryId={categoryId}
                                   data={data?.prompts}
                              />
                         </Suspense>
                    </section>

                    <section className="usage-guide">
                         <h2>How to use these prompts</h2>
                         <div className="guide-grid">
                              {getGuide(data.heroTitle)?.map((step, i) => (
                                   <div className="guide-card" key={i}>
                                        <h3>{step.title}</h3>
                                        <p>{step.desc}</p>
                                   </div>
                              ))}
                         </div>
                    </section>

                    <section className="faq-alt">
                         <h3>Frequently Asked Questions</h3>
                         <div className="faq-grid-alt">
                              {data.faqs.map((faq, i) => (
                                   <div className="faq-item" key={i}>
                                        <h4>{faq.q}</h4>
                                        <p>{faq.a}</p>
                                   </div>
                              ))}
                         </div>
                    </section>

                    <div className="final-note">
                         <h3>Final Words</h3>
                         <p>{data.finalWords}</p>
                    </div>

                    <CommentSection promptTitleProp={data?.id} />

                    <section className='seo-content mt-5'>
                         <div className='__container'>
                              <h1>{data?.seo_title}</h1>
                              <p className='mt-5'> {data?.seo_description}</p>
                              <code className='opacity-0 invisible'>{data?.seo_keywords}</code>
                         </div>
                    </section>
               </div>

          </>

     );
};

export default CategoryPreview;